import React from "react";

const withAutoRefresh = (Component, refreshConditionFunc, onRefreshFunc, refreshTime = 5000) => {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        isRefreshing: false
      };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (
        this.state.timeout &&
        this.state.isRefreshing &&
        nextProps.location.search !== this.props.location.search
      ) {
        window.clearTimeout(this.state.timeout);
        this.setState({ timeout: undefined, isRefreshing: false });
      } else if (refreshConditionFunc(nextProps) && !this.state.isRefreshing) {
        const refreshInterval = document.hidden ? refreshTime * 3 : refreshTime;
        const timeout = window.setTimeout(() => {
          onRefreshFunc(nextProps);
          this.setState({ isRefreshing: false });
        }, refreshInterval);
        this.setState({ isRefreshing: true, timeout });
      }
    }

    componentWillUnmount() {
      window.clearTimeout(this.state.timeout);
    }

    render() {
      return <Component {...this.props} isRefreshing={this.state.isRefreshing} />;
    }
  };
};

export default withAutoRefresh;
